import type { ComponentType } from 'react';

export type InputWidgetProps = {
  /**
   * Called by the widget when the consultant has picked a value. The string is
   * fed into the chat as if the user had typed it (then validated server-side
   * by the param's `validate` callback).
   */
  onSubmit: (value: string) => void;
  /**
   * True while a server step request is in flight; widgets should disable
   * controls.
   */
  disabled?: boolean;
};

export type InputWidget = ComponentType<InputWidgetProps>;

const registry = new Map<string, InputWidget>();

export const registerInputWidget = (
  kind: string,
  widget: InputWidget
): void => {
  registry.set(kind, widget);
};

export const getInputWidget = (kind: string): InputWidget | undefined =>
  registry.get(kind);

export const __resetInputWidgetRegistryForTests = (): void => {
  registry.clear();
};
